module.exports = __webpack_public_path__ + "static/media/高新技术企业.f20c8f8b.png";